export { NOOP, toRawType } from '@vue/shared'



// const objectToString = Object.prototype.toString

// const toTypeString = (value: unknown) => objectToString.call(value)

// // 是否是函数
// export function isFunction(val: unknown): val is (...args: any[]) => any {
//     return toTypeString(val) === '[object Function]'
// }